// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-textarea {
  width: 100%;
  height: 11.8rem;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--black);
  background: transparent !important;
  border: 0;
  outline: none;
  resize: none;
}
.app-textarea::placeholder {
  color: var(--grey-text);
}`, "",{"version":3,"sources":["webpack://./src/shared/textarea/textarea.component.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,eAAA;ECHA,iBAAA;EACA,mBAAA;EDIA,mBAAA;EACA,kCAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AAAF;AAEE;EACE,uBAAA;AAAJ","sourcesContent":["@import 'src/styles/mixins';\n\n.app-textarea {\n  width: 100%;\n  height: 11.8rem;\n  @include button-text;\n  color: var(--black);\n  background: transparent !important;\n  border: 0;\n  outline: none;\n  resize: none;\n\n  &::placeholder {\n    color: var(--grey-text);\n  }\n}","@mixin button-text {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n}\n\n@mixin button-medium-text {\n  font-size: 1.2rem;\n  line-height: 1.4rem;\n}\n\n@mixin small-button-text {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n}\n\n@mixin label {\n  font-size: 1.4rem;\n  line-height: 1.8rem;\n  font-weight: 500;\n}\n\n@mixin full {\n  &.full {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
